import { AudioCodeModelEnum } from "./api/AIApi";
import Global from "./Global";
import { ColorEnum } from "./SuperEnum";
import Tools from "./Tools";
import VoiceModelVO from "./vo/edgetts/VoiceModelVO";

/**
 * 声音播放
 */
export class AudioPlayer {
    /**
     * 是否已完成
     */
    public IsFinish: boolean = false;
    public Index: number = 0;
    public GUID: string = "";
    private useModel: VoiceModelVO | null = null;
    public text: string = "";
    public audioCodeModel: AudioCodeModelEnum = AudioCodeModelEnum.None;
    /**
     * 连接
     */
    public link: string = "";
    public blob: Blob | null = null;
    public base64Audio: string = "";
    /**
     * 媒体时长
     */
    public duration: number = 0;
    /**
     * 音频播放上下文
     */
    private audioContext?: AudioContext;
    /**
     * 最大尝试次数
     */
    private maxTryCount: number = 3;
    /**
     * 是否已停止
     */
    private isStop: boolean = false;
    private source: AudioBufferSourceNode | null = null;
    constructor(index: number, _text: string, _useModel: VoiceModelVO, maxTryCount: number = 3) {
        this.Index = index; //当前索引
        this.GUID = Tools.GUID;
        this.useModel = _useModel;
        this.text = _text;
        this.maxTryCount = maxTryCount;
    }

    /**
     * 返回基础数据信息
     * @returns 
     */
    public ShowBaseData(): {
        text: string,
        blob: Blob | null,
        link: string,
        duration: number,
        base64Audio: string
    } {
        return {
            duration: this.duration,
            text: this.text,
            blob: this.blob,
            base64Audio: this.base64Audio,
            link: this.link
        }
    }

    /**
     * 停止播放
     */
    public Stop() {
        this.isStop = true;
        this.source?.stop();
    }

    /**
     * 尝试加载
     * @returns 
     */
    public async ToLoadAsync(audioCodeModel: AudioCodeModelEnum): Promise<AudioPlayer> {
        try {
            while (this.maxTryCount > 0) {
                try {
                    let resp = await Global.api.aiApi.ConvertTextToAudioAsync(this.useModel?.Name!, this.text, audioCodeModel);
                    if (resp.CheckIsOk(false)) {
                        this.audioCodeModel = audioCodeModel;
                        if (resp.Data instanceof Blob) {
                            this.blob = resp.Data!;
                        }
                        else {
                            const d = resp.Data;
                            if (d) {
                                this.base64Audio = d.Base64Audio ?? "";
                                this.link = d.Link ?? "";
                                this.duration = d.MediaDuration ?? 0;
                            }

                        }
                        return this;
                    }
                }
                catch (ex) {
                    "请求音频失败".Log("AudioPlayer", ColorEnum.Error);
                }
                finally {
                    this.maxTryCount--;
                }
            }
            return this;
        }
        catch (ex) {
            return this;
        }
        finally {
            this.IsFinish = true;
        }
    }

    /**
     * 进行播放
     * @returns 
     */
    public ToPlayAsync(): Promise<boolean> {
        return new Promise<boolean>(r => {
            try {
                const w = globalThis;
                this.audioContext = new (w.AudioContext || (w as any).webkitAudioContext)();
                // const audioData = new Blob(['Hello, this is a test audio'], { type: 'audio/wav' });
                // 使用 FileReader 将 Blob 数据转换为 ArrayBuffer 类型
                const reader = new FileReader();
                // 当 FileReader 读取完成时的回调函数
                reader.onload = () => {
                    // 获取读取结果，即 ArrayBuffer
                    const arrayBuffer = reader.result as ArrayBuffer;
                    this.audioContext!.decodeAudioData(arrayBuffer, (audioBuffer) => {
                        try {
                            // 创建一个 AudioBufferSourceNode 并将解码后的音频数据设置为其 buffer 属性
                            this.source = this.audioContext!.createBufferSource();
                            this.source.buffer = audioBuffer;
                            // 连接 AudioBufferSourceNode 到 AudioContext 的目的地，通常是扬声器
                            this.source.connect(this.audioContext!.destination);
                            // 开始播放音频，start 方法的参数 0 表示从音频的起始位置开始播放
                            this.source.start(0);
                            this.source.addEventListener("ended", (ev) => {
                                r(true);
                            }, {
                                once: true
                            }); //播放完毕
                        }
                        catch (ex) {
                            r(false);
                        }

                    }, (error) => {
                        console.error('Error decoding audio data:', error);
                        r(false);
                    });
                };
                // 当 FileReader 发生错误时的回调函数
                reader.onerror = function () {
                    console.error('Error reading Blob:', reader.error);
                    r(false);
                };
                // 开始读取 Blob 数据作为 ArrayBuffer
                reader.readAsArrayBuffer(this.blob!);
            }
            catch (ex) {
                r(false);
            }
        });
    }
}

/**
 * TTS音频合成播放器
 */
export default class TTSPlayer {
    //是否停止
    private isStop: boolean = false;
    /**
     * 是否正在播放
     */
    private _isPlaying: boolean = false;

    public get isPlaying(): boolean {
        return this._isPlaying;
    }

    public set isPlaying(v: boolean) {
        if (v == false)
            this.currentPlayer = null;
        this._isPlaying = v;
    }


    private useModel: VoiceModelVO | null = null;
    /**
     * 当天播放
     */
    private currentPlayer: AudioPlayer | null = null;

    /**
     * 等待播放的文本队列
     */
    private taskQueue: AudioPlayer[] = [];
    /**
     * 等待播放
     */
    private waitPlayQueue: AudioPlayer[] = [];
    /**
     * 同时并发数
     */
    private concurrentCount: number = 5;

    /**
     * 语音合成播放器
     * @param model 
     */
    constructor() {

    }

    /**
     * 开始播放
     * @param content 
     */
    public async ToPlayAsync(content: string, model: VoiceModelVO, audioCodeModel: AudioCodeModelEnum = AudioCodeModelEnum.Audio) {
        await this.ToStopAsync();

        this.isStop = false;

        this.useModel = model;
        //进行文本切割
        this.TextPreprocessing(content, [
            '。',
            '.',
            ',',
            '，',
            '！',
            '!',
            "？",
            '?']);
        //进行索引编号
        for (let i = 0; i < this.taskQueue.length; i++) {
            this.taskQueue[i].Index = i;
            this.waitPlayQueue.push(this.taskQueue[i]);
            if (this.isStop)
                break;
        }
        //进行播放
        await this.RunConcurrentTasksAsync(audioCodeModel);
    }

    /**
     * 生成音频数据
     * @param content 
     * @param model 
     */
    public async TryGenerateAudioListAsync(content: string, model: VoiceModelVO, audioCodeModel: AudioCodeModelEnum) {
        this.useModel = model;
        //进行文本切割
        this.TextPreprocessing(content, [
            '。',
            '.',
            ',',
            '，',
            '！',
            '!',
            "？",
            '?']);
        //进行索引编号
        for (let i = 0; i < this.taskQueue.length; i++) {
            this.taskQueue[i].Index = i;
            this.waitPlayQueue.push(this.taskQueue[i]);
            if (this.isStop)
                break;
        }
        //进行播放
        return await this.ToGenerateAsync(audioCodeModel);
    }

    /**
     * 执行生成
     */
    private async ToGenerateAsync(audioCodeModel: AudioCodeModelEnum) {
        const runningTasks: Promise<{ task: Promise<AudioPlayer>, nextPlay: AudioPlayer, taskIndex: number } | null>[] = []; // 当前运行的任务队列

        /**
         * 初始化任务总数
         */
        for (let i = 0; i < this.concurrentCount; i++) {
            runningTasks.push(null as any);
        }

        //获取空索引(-1说明没有)
        const GetNullIndex = () => {
            for (let i = 0; i < runningTasks.length; i++) {
                if (runningTasks[i] == null)
                    return i;
            }
            return -1;
        }

        while (this.taskQueue.length > 0 || GetNullIndex() >= 0) {
            if (this.isStop)
                return;
            let useIndex = GetNullIndex();
            while (useIndex > -1 && this.taskQueue.length > 0) {
                if (this.isStop)
                    return;
                const nextPlay = this.taskQueue.shift();
                const taskPromise = nextPlay!.ToLoadAsync(audioCodeModel);
                `${nextPlay?.text}`.Log("AUDIO音频合成文本压入", ColorEnum.Info);
                runningTasks[useIndex] = this.WrapTask(taskPromise, nextPlay!, useIndex);
                useIndex = GetNullIndex();
            }
            // 等待任何一个任务完成
            const waitList = runningTasks.Where(x => x != null);
            if (waitList.length > 0) {
                const { task, nextPlay, taskIndex } = (await Promise.race(waitList))!;
                // 移除已完成任务
                runningTasks[taskIndex] = null as any;
                nextPlay.IsFinish = true;
                `${nextPlay.text}`.Log("完成一个音频合成", ColorEnum.Info);
            }
            else {
                `合成结束!`.Log('AUDIO音频合成加载成功', ColorEnum.Success);
                break;
            }
        }

        return this.waitPlayQueue; //全部完成;

    }


    /**
     * 停止播放
     */
    public async ToStopAsync() {
        if (this.isPlaying)
            this.isStop = true;
        this.currentPlayer?.Stop();
        //进行停止
        this.waitPlayQueue.Clear();
        this.taskQueue.Clear();
        await Tools.SleepAsync(1500);
    }

    /**
     * 并发执行
     */
    private async RunConcurrentTasksAsync(audioCodeModel: AudioCodeModelEnum) {
        const runningTasks: Promise<{ task: Promise<AudioPlayer>, nextPlay: AudioPlayer, taskIndex: number } | null>[] = []; // 当前运行的任务队列

        /**
         * 初始化任务总数
         */
        for (let i = 0; i < this.concurrentCount; i++) {
            runningTasks.push(null as any);
        }

        //获取空索引(-1说明没有)
        const GetNullIndex = () => {
            for (let i = 0; i < runningTasks.length; i++) {
                if (runningTasks[i] == null)
                    return i;
            }
            return -1;
        }


        while (this.taskQueue.length > 0 || GetNullIndex() >= 0) {
            if (this.isStop)
                return;
            let useIndex = GetNullIndex();
            while (useIndex > -1 && this.taskQueue.length > 0) {
                if (this.isStop)
                    return;
                const nextPlay = this.taskQueue.shift();
                const taskPromise = nextPlay!.ToLoadAsync(audioCodeModel);
                `${nextPlay?.text}`.Log("AUDIO音频压入", ColorEnum.Info);
                runningTasks[useIndex] = this.WrapTask(taskPromise, nextPlay!, useIndex);
                useIndex = GetNullIndex();
            }
            // 等待任何一个任务完成
            const waitList = runningTasks.Where(x => x != null);
            if (waitList.length > 0) {
                const { task, nextPlay, taskIndex } = (await Promise.race(waitList))!;
                // 移除已完成任务
                runningTasks[taskIndex] = null as any;
                nextPlay.IsFinish = true;
                `${nextPlay.text}`.Log("完成一个音频合成", ColorEnum.Info);
            }
            else {
                `音频加载已结束!`.Log('AUDIO音频加载成功', ColorEnum.Success);
                break;
            }

            //尝试播放
            this.TryPlayAsync();

        }
    }


    /**
     * 尝试播放
     */
    private async TryPlayAsync() {
        try {
            if (this.isStop)
                return;
            if (this.isPlaying)
                return;
            this.isPlaying = true;
            if (this.waitPlayQueue.length > 0) {

                let top = this.waitPlayQueue[0];
                if (top.IsFinish) {
                    this.currentPlayer = top;
                    //进行播放
                    const playOk = await top.ToPlayAsync();
                    if (playOk) {
                        `${top.text}`.Log("AUDIO成功播放", ColorEnum.Success);
                    }
                    else {
                        `${top.text}`.Log("AUDIO播放失败", ColorEnum.Error);
                    }
                    this.waitPlayQueue.shift();
                    this.isPlaying = false;
                    await this.TryPlayAsync();
                }
                else {
                    this.isPlaying = false;
                }
            }
            else {
                this.isPlaying = false;
            }
        }
        catch (ex) {
            this.isPlaying = false;
        }

    }

    /**
     * 包装任务为包含索引的任务
     */
    private WrapTask(task: Promise<AudioPlayer>, nextPlay: AudioPlayer, taskIndex: number): Promise<{ task: Promise<AudioPlayer>, nextPlay: AudioPlayer, taskIndex: number }> {
        return task.then(
            (result) => ({ task: result, nextPlay, taskIndex }),
            (error) => ({ task: error, nextPlay, taskIndex }) // 即使任务失败，也返回结构化数据
        ) as any;
    }


    /**
     * 文本预处理(递归切割)
     * @param text 文本内容
     * @param cutIdentifier 切割内容
     */

    private TextPreprocessing(text: string, cutIdentifiers: string[]): void {
        if (cutIdentifiers.length == 0) {
            if (Tools.IsNotNull(text))
                this.taskQueue.push(new AudioPlayer(0, text, this.useModel!));
            return;
        }
        const cut_char = cutIdentifiers[0];
        const arr = text.split(cut_char);
        for (let k = 0; k < arr.length; k++) {
            this.TextPreprocessing(arr[k], cutIdentifiers.slice(1))
        }
    }
}